<template>
  <div class="about">
    <!-- <div class="aboutNav" /> -->
    <!-- -----------------------仓储管理系统(WMS) -->
    <CaseTop :topTitle="topTitle" :topType="topType" />

    <!-- ----------------------------产品概述 -->
  
    <ProjectMilitaryOverview :overViewText='overViewText' />


    <!-- ---------------------------应用领域 -->
    <div class="three" :style="{ width: this.threeWidth.width + 'px' }" style="height: 673px;">
      <div class="font3">
        <p>应用领域</p>
      </div>
      <div class="box">
        <AboutOneApplicationArea v-for="(item, index) in info" :key="index" :item="item" />
      </div>
    </div>

    <!-- --------------------------------------- 主要功能 -->
    <div class="four" :style="{ width: this.fourWidth.width + 'px' }" style="height: 802px;">
      <div class="wmsFont4">
        <p style="width:9% ;height:20%">主要功能</p>
      </div>
      <div class="multi-purpose" style="width: 100%; height:75%;position: relative;margin-top: 60px;">
        <div class="all" style="width: 1096px; height:537px">

          <!-- 导航栏 -->
          <nav class="menu" style="width: 100%; height:11%">
            <div class="menu-router" style=" margin-left:2%;width: 10%; height: 100%;">
              <AboutOneMenu  :menuItem="menuItem1" />
            </div>
            <div class="menu-router" style="margin-left: 1%;width: 10%; height: 100%;">
              <AboutOneMenu  :menuItem="menuItem2" />
            </div>
            <div class="menu-router" style="margin-left: 1%;width: 10%; height: 100%;">
              <AboutOneMenu  :menuItem="menuItem3" />
            </div>
            <div class="menu-router" style="margin-left: 1%;width: 10%; height: 100%;">
              <AboutOneMenu  :menuItem="menuItem4" />
            </div>
            <div class="menu-router" style="margin-left: 1%;width: 10%; height: 100%;">
              <AboutOneMenu  :menuItem="menuItem5" />
            </div>
            <div class="menu-router" style="margin-left: 1%;width: 12%; height: 100%;">
              <AboutOneMenu  :menuItem="menuItem6" />
            </div>
            <div class="menu-router" style="margin-right: 4%;width: 14%; height: 100%;">
              <AboutOneMenu  :menuItem="menuItem7" />
            </div>
          </nav>

          <!-- 点击导航项显示下面不同的内容 -->
          <div class="menu-content" style="width: 86%; height:89%">

            <div class="contentItem">
              <AboutOneMenuContent  :contentItem="contentItem1" />
            </div>

            <div class="contentItem">
              <AboutOneMenuContent  :contentItem="contentItem2" />
            </div>

            <div class="contentItem">
              <AboutOneMenuContent  :contentItem="contentItem3" />
            </div>

            <div class="contentItem">
              <AboutOneMenuContent  :contentItem="contentItem4" />
            </div>

            <div class="contentItem">
              <AboutOneMenuContent  :contentItem="contentItem5" />
            </div>

            <div class="contentItem">
              <AboutOneMenuContent  :contentItem="contentItem6" />
            </div>

            <div class="contentItem">
              <AboutOneMenuContent  :contentItem="contentItem7" />
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- --------------------------------硬件支持 -->
    <div class="AboutOneHardwareSupport"
      :style="{ width: this.fiveWidth.width + 'px' }" style="height:2005px">
      <!-- 硬件支持第一大部分 -->
      <div style="width:100% ;height: 986px;">

        <div class="supportFont5" style="width: 100%; height:195px">
        <h2>硬件支持</h2>
      </div>

        <div class="supportOnly" style="width:100%;height: 81%;">

     <div class="tool" style="width:1071px;height: 794px">

  <!-- 上面一排三个 -->
  <div class="topTool" style="width: 1071px; height: 404px">

    <div class="top-box">
      <AboutOneSupportOnlyDiv  :hardItem="wmsItem1"></AboutOneSupportOnlyDiv>
    </div>

    <div class="top-box">
      <AboutOneSupportOnlyDiv  :hardItem="wmsItem2"></AboutOneSupportOnlyDiv>
    </div>

    <div class="top-box">
      <AboutOneSupportOnlyDiv  :hardItem="wmsItem3"></AboutOneSupportOnlyDiv>
    </div>
  </div>

  <!-- 下面一排三个 -->
  <div class="bottomTool" style="width: 1071px; height:385px">
    <div class="bottom-box">
      <AboutOneSupportOnlyDiv  :hardItem="wmsItem4"></AboutOneSupportOnlyDiv>
    </div>

    <div class="bottom-box">
      <AboutOneSupportOnlyDiv  :hardItem="wmsItem5"></AboutOneSupportOnlyDiv>
    </div>

    <div class="bottom-box">
      <AboutOneSupportOnlyDiv  :hardItem="wmsItem6"></AboutOneSupportOnlyDiv>
    </div>
  </div>


</div>
</div>
      </div>
      <!-- 申请试用 -->
      <div class="apply" style="width:100% ;height:24%">
        <div class="total" style="width:100% ;height:100%">
          <AboutOneApplyTryDiv />
        </div>
      </div>

      <!-- 实际案例 -->
      <Others  :index="index" :currentType="currentType" :topType="topType"  :arrayIndex="2" />
    </div>

    <!-- 关于我们 -->
    <div :style="{ width: this.sixWidth.width + 'px', height: this.sixWidth.height + 'px' }">
      <contactUs :pageType="1" />
    </div>

  </div>
</template>

<script>
// 顶部标题
import CaseTop from '../components/CaseTop.vue'
// 关于我们
import contactUs from '../components/contactUs.vue'
// 产品概述
import ProjectMilitaryOverview from '../components/ProjectMilitaryOverview.vue'
// 主要功能导航栏
import AboutOneMenu from '../components/AboutOneMenu.vue'
// 主要功能导航栏对应内容
import AboutOneMenuContent from '../components/AboutOneMenuContent.vue'
// 应用领域
import AboutOneApplicationArea from '../components/AboutOneApplicationArea.vue'
// 硬件支持
import AboutOneSupportOnlyDiv from '../components/AboutOneSupportOnlyDiv.vue'
// 申请试用
import AboutOneApplyTryDiv from '../components/AboutOneApplyTryDiv.vue'
// 实际案例
import Others from '../components/Others.vue'


// 应用领域
import areaImg1 from '../assets/aboutOneApplicationArea/makeIcon1.webp'
import areaImg2 from '../assets/aboutOneApplicationArea/consumerIcon.webp'
import areaImg3 from '../assets/aboutOneApplicationArea/logisticsIcon.webp'
import areaImg4 from '../assets/aboutOneApplicationArea/businessIcon.webp'

// 硬件支持
import wmsWare1 from '../assets/aboutOneHardware/server1.png'
import wmsWare2 from '../assets/aboutOneHardware/data.png'
import wmsWare3 from '../assets/aboutOneHardware/network.png'
import wmsWare4 from '../assets/aboutOneHardware/huoWu.png'
import wmsWare5 from '../assets/aboutOneHardware/jianKong.png'
import wmsWare6 from '../assets/aboutOneHardware/intelligence.png'


// 主要功能
import wmsFunction1 from '../assets/AboutWMSMainFunction/function1.png'
import wmsFunction2 from '../assets/AboutWMSMainFunction/function2.png'
import wmsFunction3 from '../assets/AboutWMSMainFunction/function3.png'
import wmsFunction4 from '../assets/AboutWMSMainFunction/function4.png'
import wmsFunction5 from '../assets/AboutWMSMainFunction/function5.png'
import wmsFunction6 from '../assets/AboutWMSMainFunction/function6.png'
import wmsFunction7 from '../assets/AboutWMSMainFunction/function7.png'
import wmsBackground from '../assets/AboutWMSMainFunction/background.png'



export default {
  name: 'AboutOneView',
  components: {
    CaseTop,
    contactUs,
    ProjectMilitaryOverview,
    AboutOneMenu,
    AboutOneMenuContent,
    AboutOneSupportOnlyDiv,
    AboutOneApplyTryDiv,
    AboutOneApplicationArea,
    Others
  },
  mounted() {
    //加载后先计算一遍缩放比例
    this.Scale();
    //生成一个监听器：窗口发生变化从新计算计算一遍缩放比例
    window.addEventListener('resize', this.Scale);

    // 实际案例部分

    //获取图片样式
    this.slides = document.querySelectorAll('.slide');
    //根据索引居中
    this.centerSlide(this.currentIndex);
    // 定时器  自动轮播，每3秒切换一次图片
    this.startTime();


    // 主要功能部分点击导航切换内容
    this.changeContent();
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    clearInterval(this.startTime);
  },
  data() {
    return {
      oneWidth: {
        width: '1920',
        height: '400'
      },
      twoWidth: {
        width: '1919',
        height: '472'
      },
      threeWidth: {
        width: '1919',
        height: '614'
      },
      fourWidth: {
        width: '1920',
        height: '802'
      },
      fiveWidth: {
        width: '1920',
        height: '2001'
      },
      sixWidth: {
        width: '1920',
        height: '533'
      },
      // 顶部标题
      topTitle:'仓储管理系统(WMS)',
      topType:0,

      // 产品概述
      overViewText: 'WMS主要用于仓库内部的货物存储、库存管理、订单处理、发货运输等环节，有效提升仓库运营的效率、降低成本，实现仓库精细化管理,基本功能包括库存管理、入库管理、出库管理、移库管理、盘点管理、库存预警、统计分析等。其中，库存管理是WMS系统的核心功能，通过对货物的上架、下架、查询等操作进行全面管控，有效提高仓库利用率和货物准确率，WMS还具备其他扩展功能，如智能预测、智能补货、数据分析等，同时，结合RF技术，WMS系统可以快速、准确地完成货物的识别、录入等操作，极大提升了仓库运营的效率，此外，WMS系统还可以与其他管理系统（如ERP、TMS等）进行无缝集成，实现数据的共享和协同作业，进一步优化企业的整体运营效率',

      // 硬件支持
      wmsItem1: {text:'服务器', content: 'WMS系统通过数据库进行信息传输和实时监控，服务器即是WMS系统的数据中心，实时地获取仓库内各个区域的数据，并将数据传输到中央服务器进行处理和分析，需要24小时连续运行', hard: wmsWare1, hardWidth: '70.4', hardHeight: '67',iconRight:'5',iconBottom:'1' },
      wmsItem2: {text:'数据采集终端', content: '通过扫描条形码或RFID标签来实现货物的快速识别和采集信息。数据采集终端可以采集货物的数量、位置、批次号等重要信息，并将数据实时传输到WMS系统', hard: wmsWare2, hardWidth: '24.3', hardHeight: '95',iconRight:'5',iconBottom:'-2' },
      wmsItem3: {text:'无线网络设备', content: '无线网络设备可以为数据采集终端提供稳定的网络连接，保证数据的实时传输和交互。同时，也可以为仓库管理人员提供更加便捷的工作方式，实现移动办公，提高工作效率', hard: wmsWare3, hardWidth: '65', hardHeight: '54',iconRight:'0',iconBottom:'2' },
      wmsItem4: {text:'货架和托盘', content: '合理的货架和托盘的使用可以最大限度地提高仓库的存储空间利用率和货物的存取效率。同时，WMS系统也可以通过条形码或RFID标签管理货架和托盘的使用情况，实现对货物的精确跟踪和管理', hard: wmsWare4, hardWidth: '61', hardHeight: '67',iconRight:'6',iconBottom:'-1' },
      wmsItem5: {text:'智能传感器', content: '可以实时监测仓库内的温度、湿度、光照等环境参数，保证货物的质量和安全。并且与WMS系统进行连接，及时将环境数据传输到系统中进行分析和记录。当环境参数超出设定范围时，系统可以自动发出警报，提醒仓库管理人员采取相应的措施，保证货物的存储条件', hard: wmsWare6, hardWidth: '41.8', hardHeight: '55',iconRight:'7',iconBottom:'-3' },
      wmsItem6: {text:'安防监控设备', content: '安防监控设备包括摄像头、报警器、门禁系统等。它们可以实时监测仓库内的情况，记录不同区域的活动,并在有异常情况发生时及时发出警报。通过与WMS系统的联动,仓库管理人员可以随时通过系统监控仓库的安全状态,防范各种风险和突发事件的发生', hard: wmsWare5, hardWidth: '82', hardHeight: '49.7',iconRight:'10',iconBottom:'-2' },
      
      // 主要功能导航栏
      menuItem1:{menuMsg:'库存管理'},
      menuItem2:{menuMsg:'入库管理'},
      menuItem3:{menuMsg:'出库管理'},
      menuItem4:{menuMsg:'货位管理'},
      menuItem5:{menuMsg:'订单管理'},
      menuItem6:{menuMsg:'运输管理'},
      menuItem7:{menuMsg:'报告和分析'},

      // 主要功能内容
      contentItem1:{menuContent:'WMS系统可以帮助企业实现对库存的管理和控制。它可以实时监控库存数量、位置和状态，并提供库存报告和分析。WMS系统还可以帮助企业实现库存的自动化管理，包括自动补货、自动分配和自动转移等',menuImg:wmsFunction1, menuWidth: '92', menuHeight: '79',menuSpanTop:'16',menuTop:'17',backImg:wmsBackground,backWidth:'60',backHeight:'43',backLeft:'-15',backBottom:'0'},
      contentItem2:{menuContent:' WMS系统可以帮助企业实现对入库流程的管理和控制。它可以自动识别入库物品的信息，并将其与库存系统进行同步。WMS系统还可以帮助企业实现入库流程的自动化管理，包括自动分配入库位置、自动打印标签和自动更新库存信息等',menuImg:wmsFunction2, menuWidth: '100', menuHeight: '70',menuSpanTop:'16',menuTop:'17',backImg:wmsBackground,backWidth:'60',backHeight:'43',backLeft:'-15',backBottom:'0'},
      contentItem3:{menuContent:' WMS系统可以帮助企业实现对出库流程的管理和控制。它可以自动识别出库物品的信息，并将其与库存系统进行同步。WMS系统还可以帮助企业实现出库流程的自动化管理，包括自动分配出库位置、自动打印标签和自动更新库存信息等',menuImg:wmsFunction3, menuWidth: '95', menuHeight: '79',menuSpanTop:'16',menuTop:'17',backImg:wmsBackground,backWidth:'60',backHeight:'43',backLeft:'-15',backBottom:'0'},
      contentItem4:{menuContent:'WMS系统可以帮助企业实现对货位的管理和控制。它可以自动分配货位、监控货位状态和提供货位报告和分析。WMS系统还可以帮助企业实现货位的自动化管理，包括自动分配货位、自动更新货位状态和自动转移货位等',menuImg:wmsFunction4, menuWidth: '100', menuHeight: '70',menuSpanTop:'16',menuTop:'17',backImg:wmsBackground,backWidth:'60',backHeight:'43',backLeft:'-15',backBottom:'0'},
      contentItem5:{menuContent:' WMS系统可以帮助企业实现对订单的管理和控制。它可以自动识别订单信息、分配订单任务和监控订单状态。WMS系统还可以帮助企业实现订单的自动化管理，包括自动分配订单任务、自动更新订单状态和自动通知客户等',menuImg:wmsFunction5, menuWidth: '100', menuHeight: '79',menuSpanTop:'16',menuTop:'10',backImg:wmsBackground,backWidth:'60',backHeight:'43',backLeft:'-15',backBottom:'0'},
      contentItem6:{menuContent:' WMS系统可以帮助企业实现对运输的管理和控制。它可以自动识别运输信息、分配运输任务和监控运输状态。WMS系统还可以帮助企业实现运输的自动化管理，包括自动分配运输任务、自动更新运输状态和自动通知客户等',menuImg:wmsFunction6, menuWidth: '105', menuHeight: '76',menuLeft:'-10',menuSpanTop:'16',menuTop:'10',backImg:wmsBackground,backWidth:'60',backHeight:'43',backLeft:'-15',backBottom:'0'},
      contentItem7:{menuContent:' WMS系统可以帮助企业实现对仓库运营的报告和分析。它可以提供库存报告、订单报告、运输报告和货位报告等。WMS系统还可以帮助企业进行数据分析，包括库存分析、订单分析、运输分析和货位分析等',menuImg:wmsFunction7, menuWidth: '100', menuHeight: '76',menuLeft:'-5',menuSpanTop:'16',menuTop:'9',backImg:wmsBackground,backWidth:'60',backHeight:'43',backLeft:'-15',backBottom:'0'},
      // 实际案例
      index:-1,
      currentType: 2,

      carText1: '机动实操考核系统',
      carText2: '设备台站模拟训练系统',
      carText3: '红蓝双方兵力对抗系统',
      carImage1: areaImg1,
      carImage2: areaImg2,
      carImage3: areaImg3,
      carFieldImgs: [areaImg1, areaImg2, areaImg3],
      carFieldTexts: ['机动实操考核系统', '设备台站模拟训练系统', '红蓝双方兵力对抗系统'],

      currentIndex: 0,//当前显示的图片索引

      intervalId: null, //用于存储定时器ID

      // 应用领域
      info: [

        { p1: '制造行业', span: '我国制造业和物流业聚集了大量中小微企业，而制造业向来是大国经济的“压舱石”，对推动经济增长和提高就业质量至关重要。制造业的仓库管理大多数都是以传统的手工作业模式，通过WMS系统将仓库作业自动化，自动跟踪和管理原材料和成品，以优化生产和分发流程', isActive: false, backgroundImage: areaImg1 },
        { p1: '零售消费品行业', span: '随着线上线下的融合，多渠道/全渠道、多业态订单剧增，WMS可以帮助零售消费品行业的企业管理存货、跟踪货物状态，减少库存呆滞，并通过预测需求来避免库存积压，大幅提高零售消费品企业的仓库管理运营效率', isActive: false, backgroundImage: areaImg2 },
        { p1: '三方物流行业', span: '大多数物流企业对库存周转率有很高的需求，通过WMS 可以帮助物流公司更有效地管理仓库空间，优化货物的存储和检索，从而提高效率，降低成本，提升客户满意度的同事增加企业竞争力', isActive: false, backgroundImage: areaImg3 },
        { p1: '电商行业', span: '随着电子商务市场的不断扩大，电商企业的订单量和仓储物流管理难度也不断增加。通过WMS系统，电商企业可以实时掌握仓库内的库存情况、订单信息和出库状态等，可以及时处理订单、发货和退换货等业务，为客户提供高质量的服务和快速的物流支持', isActive: false, backgroundImage: areaImg4 }
      ],
    }
  },
  methods: {
    Scale() {
      if (document.body.clientWidth < 1200) {
        this.oneWidth.width = 1200;
        this.oneWidth.height = 250;

        this.twoWidth.width = 1200;
        // this.twoWidth.height = 295

        this.threeWidth.width = 1200;
        // this.threeWidth.height = 616;

        this.fourWidth.width = 1200;
        // this.fourWidth.height = 503

        this.fiveWidth.width = 1200;
        // this.fiveWidth.height = 1251

        this.sixWidth.width = 1200;
        this.sixWidth.height = 333
      } else {
        this.oneWidth.height = 0.21 * document.body.clientWidth;
        this.oneWidth.width = document.body.clientWidth;

        // this.twoWidth.height = 0.25 * document.body.clientWidth;
        this.twoWidth.width = document.body.clientWidth;
        // 0.32 * document.body.clientWidth;
        // this.threeWidth.height = 616;
        this.threeWidth.width = document.body.clientWidth;

        // this.fourWidth.height = 0.42 * document.body.clientWidth;
        this.fourWidth.width = document.body.clientWidth;

        // this.fiveWidth.height = 1.04 * document.body.clientWidth;
        this.fiveWidth.width = document.body.clientWidth;

        this.sixWidth.height = 0.28 * document.body.clientWidth;
        this.sixWidth.width = document.body.clientWidth;
      }
    },

    /*锁定选定的盒子判断他是否选定 */
    // divClick(index) {
    //   /** 当 “点击” 一个“已被点击”的div时 使该div恢复默认色 */
    //   // 遍历info数组中的每个对象
    //   for (let i of this.info) {
    //     // 判断当前对象是否和传入的索引index对应 如果是，则取反
    //     if (index === this.info.indexOf(i)) {
    //       i.isActive = !i.isActive
    //     } else {
    //       i.isActive = false;
    //     }
    //   }
    // },

    // 鼠标滑过时，显示背景图片和修改文字颜色
    mouseOver(index) {
      this.info[index].isActive = true;
    },

    // 鼠标离开时则恢复默认
    mouseLeave(index) {
      this.info[index].isActive = false;
    },


    /*给选定的盒子修改样式 */
    colorDiv(index) {
      if (this.info[index].isActive) {
        return {
          backgroundImage: `url(${this.info[index].backgroundImage})`,
          color: 'white'
        };
      } else {
        return {
          backgroundImage: 'none',
          '.p1 p': {
            color: '#333333;'
          },
          '.span span': {
            color: 'black'
          }
        }
      }
    },

    /*
    实际案例部分轮播切换
     */
    showSlide(index) {
      this.carImage1 = this.carFieldImgs[index];
      this.carText1 = this.carFieldTexts[index];
      this.carImage2 = this.carFieldImgs[++index % 3];
      this.carText2 = this.carFieldTexts[index % 3];
      this.carText3 = this.carFieldTexts[++index % 3];
      this.carImage3 = this.carFieldImgs[index % 3];
      this.currentIndex = (++index) % 3;
    },
    //居中显示
    centerSlide(index) {
      this.currentIndex = index;
      this.showSlide(index);
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.carFieldImgs.length;
      this.currentIndex = (this.currentIndex + 1) % this.carFieldTexts.length;
      this.showSlide(this.currentIndex);
    },

    // 定时器 自动轮播
    startTime() {
      this.intervalId = setInterval(this.nextSlide, 5000);
    },

    chanageImg(index) {
      /* 重置计时器 */
      clearInterval(this.intervalId);
      this.currentIndex = index;
      //  // 将被点击的图片居中显示
      // this.centerSlide(this.currentIndex);

      //计算需要移动的步数
      let steps = index - this.currentIndex;

      // 如果步数大于轮播图一半的长度，向前滚动到达目标图片
      if (Math.abs(steps) > this.slides.length / 2) {
        steps = steps > 0 ? steps - 3 : steps + 3;
      }

      // 更新 currentIndex，使目标图片移动到中间位置
      this.currentIndex = (this.currentIndex + steps + 3) % 3;

      // 将目标图片居中显示
      this.centerSlide(this.currentIndex);

      //重新启动定时器
      this.startTime();
    },

    // 主要功能部分切换功能
    changeContent() {
      // 在页面加载完成后先执行这个
      // document.addEventListener("DOMContentLoaded",function(){
      //   // 获取第一个菜单项
      //   var firstMenuItem = document.querySelector('.menu-router');
      //   // 让他点击第一个菜单项
      //   firstMenuItem.click();
      // })

      // 获取元素
      // var tab_list = document.querySelector('.menu');
      var list = document.querySelectorAll('.menu-router');
      var item = document.querySelectorAll('.contentItem');

      // item[0].style.display='block';
      // 获取第一个导航项
      var firstNavItem = document.querySelector('.menu-router');
      //获取第一个导航项对应的内容
      var firstContentItem = document.querySelector('.contentItem');
      // 给导航项添加样式
      firstNavItem.classList.add('menuActive');
      // 让第一导航项对应内容默认显示
      firstContentItem.style.display = 'block';

      // 分别绑定点击事件
      for (var i = 0; i < list.length; i++) {
        // 在这里创建属性，添加索引
        list[i].setAttribute('index', i);
        list[i].onclick = function () {
          // 1.第一大步骤，先解决导航栏的颜色切换
          // 所有的 menu-router清除class类
          for (var i = 0; i < list.length; i++) {
            list[i].classList.remove('menuActive');
          }
          // 自己添加上这个类
          this.classList.add('menuActive');
          // 2.第二大步骤：下面模块跟着选项卡一一匹配
          // 给上面的tab_list里面所有的li添加索引
          var index = this.getAttribute('index');
          console.log(index);
          // 先全部隐藏
          for (var j = 0; j < item.length; j++) {
            item[j].style.display = 'none';
          }
          // 当前的显示
          item[index].style.display = 'block';
        }
      }
    },


  },
}

</script>


<style>
.about {
  width: 100%;
  height: auto;
}

.aboutNav{
  width: 100%;
    height: 90px;
    background-color: #000;
}


.three {
  /* width: 1202px;
	height: 663px; */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
  background-color: #f6f6f6;
}

.font3 {
  width: 100%;
  height: 116px;
}

.font3 p {
  font-family: MySourceHanSansSC-Heavy;
  font-size: 40px;
  line-height: 30px;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #333333;
  white-space: nowrap;
  margin: 0 auto;
}

.box {
  width: 1200px;
  height: 390px;
  display: flex;
  justify-content: space-between;
  /*间隔均匀排列*/
  justify-content: center;
  /* margin: 0 auto; */
  margin: 0;
}

.four {
  background-image: url(' ../assets/mainFunctions.jpg ');
  background-size: cover;
}
.wmsFont4 {
  width: 100%;
  height: 120px;
  display: flex;
  white-space: nowrap;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  /*水平居中 */
  /*align-items: center; 垂直居中*/
  position: relative;
  /*相对定位 */
}

.wmsFont4 p {
  font-family: SourceHanSansSC-Heavsy;
  font-size: 40px;
  line-height: 30px;
  font-weight: bold;
  font-stretch: normal;
  /* line-height: 30px; */
  letter-spacing: 4px;
  color: #ffffff;
  margin: 0;
  position: absolute;
  /*绝对定位 */
  bottom: 0;
  /*让他的下边距为0 */
  /* margin-top: 50%; */
  /* margin-bottom: 50%; */
}


.multi-purpose {
  /* top: 9%; */

}

.all {
  background-color: white;
  margin: 0 auto;
}

.menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border-bottom: 1px solid rgb(112, 112, 112); */
  border-bottom: solid 1px #d3d3d3;
  border-bottom-width: 50%;
}
.menu-router {
  cursor: pointer;
  /* writing-mode: vertical-lr; */
  /*将文字垂直排列 */
  white-space: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  line-height: 1;
}


.menu-content {
  /* margin-top: 5%; */
  margin-left: 5%;
  /* margin-right: 0; */
  display: flex;
  justify-content: space-between;
}

.contentItem {
  display: none;
}

.menuActive {
  /* background-color: green; */
  border-bottom: solid 2px #ff9000;
  color: #fff;
}



.AboutOneHardwareSupport {
  /* margin: 0 auto; */
  /* display: flex;
 justify-content: center; */
  /* margin-top: 4%; */
  background-color: #f6f6f6;
}

.supportFont5 {
  display: flex;
  position: relative;
  justify-content: center;

}

.supportFont5 h2 {
  /* width: 9%;
  height: 23%; */
  font-family: MySourceHanSansSC-Heavy;
  font-size: 40px;
  line-height: 30px;
  font-weight: bold;
  font-stretch: normal;
  /* line-height: 10px; */
  letter-spacing: 2px;
  color: #333333;
  margin: 0;
  white-space: nowrap;
  position: absolute;
  top: 100px;
}

.supportOnly {
  display: flex;
  flex-direction: column;
  /*让整个容器垂直排列 */
  /* flex-wrap: wrap; */
  justify-content: space-between;
  align-items: center;
  /* margin: 0 auto; */
  /* margin-left: 17%;
  margin-right: 11%; */
  margin: 0 auto;
}

.tool {
  /* display: flex;
  justify-content: space-between; */
  /*间隔均匀排列*/
  /* justify-content: center; */
}

.topTool {
  display: flex;
  justify-content: space-between;
}

.bottomTool {
  display: flex;
  justify-content: space-between;
}

.top-box {
  width: 32%;
  height: 95%;
}

.bottom-box {
  width: 32%;
  height: 100%;
}


.apply {
  display: flex;
  position: relative;
  justify-content: center;
}

.total {}

.try {
  position: relative;
  display: flex; 
   justify-content: center;
}

/* 实际案例标题 */
.font6 h2 {
  font-family: SourceHanSansSC-Heavy;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 4px;
  color: #333333;
  margin: 0;
}


/* -----------------1201-1366之间---------------- */
@media (min-width: 1201px) and (max-width:1366px) {
  /* 实际案例标题 */
  .font6 h2 {
    font-size: 25px;
  }

}


/* -----------------1367-1600之间---------------- */
@media (min-width: 1367px) and (max-width:1600px) {

  /* 实际案例标题 */
  .font6 h2 {
    font-size: 30px;
  }
}


/* -----------------1600以上---------------- */
@media (min-width: 1600px) {
  /* 实际案例标题 */
  .font6 h2 {
    font-size: 40px;
  }


}</style>